import { useCallback, useState } from 'react'

// Custom hook for panel toggle logic
export function usePanelToggle() {
  const [showSecondPanel, setShowSecondPanel] = useState(false)

  const handleTogglePanel = useCallback(() => {
    setShowSecondPanel((prev) => !prev)
  }, [])

  return {
    showSecondPanel,
    handleTogglePanel,
  }
}
